import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import MyOrdersMenu from './MyOrdersMenu';

interface IStateFromProps {
  isLoggedIn: boolean;
}

const mapStateToProps = (state: any) => ({
  isLoggedIn: state.signin.success
});

export const pureComponent = MyOrdersMenu;

export default connect<IStateFromProps, void>(mapStateToProps)(
  withI18n()(MyOrdersMenu)
);
